import React from 'react'

type Props = {}

export default function UserPage({}: Props) {
  return (
    <div>UserPage</div>
  )
}